<template>
  <label class="input-radio">
    <input
      type="radio"
      :value="value"
      :checked="isChecked"
      v-bind="$attrs"
      v-on="listeners"
    />
    <span>{{ text }}</span>
  </label>
</template>

<script>
export default {
  name: "input-radio-item",
  inheritAttrs: false,
  props: {
    value: {},
    cValue: {},
    text: {
      default: "",
      type: String,
    },
  },
  computed: {
    listeners: function () {
      return {
        ...this.$listeners,
        input: () => this.$emit("input", this.cValue),
        click: () => this.$emit("input", this.cValue),
        change: () => this.$emit("input", this.cValue),
      };
    },
    isChecked: function () {
      return this.cValue == this.value;
    },
  },
};
</script>
